import React from 'react';
import { func, object, string } from 'prop-types';
import { useHistory } from 'react-router-dom';
import NotificationCard from '../index';

const Reminder = ({ notification, shortCode, refetch, applyOptimisticUpdate }) => {
  const { metadata } = notification;
  const { invoice, isMultiInvoice, contact, noteHash } = metadata;
  const history = useHistory();

  function getSubtitle() {
    if (isMultiInvoice) {
      return `${contact?.Name}} for multiple invoices`;
    }
    if (invoice?.InvoiceNumber) {
      return `${contact?.Name} for invoice ${invoice?.InvoiceNumber}`;
    }
    return contact?.Name;
  }

  function getLink() {
    const hash = noteHash ? `#note~${noteHash}` : '';

    if (isMultiInvoice) {
      return contact?.ContactID ? `/receivables/customer/${contact?.ContactID}${hash}` : '/receivables';
    }
    if (invoice?.InvoiceNumber) {
      return invoice?.InvoiceID ? `/receivables/invoice/${invoice?.InvoiceID}${hash}` : '/receivables';
    }
    return contact?.ContactID ? `/receivables/customer/${contact.ContactID}${hash}` : '/receivables';
  }

  return (
    <NotificationCard
      notification={notification}
      shortCode={shortCode}
      refetch={refetch}
      applyOptimisticUpdate={applyOptimisticUpdate}
      onClick={() => history.push(getLink())}
      title="You have an overdue reminder"
      subtitle={getSubtitle()}
    />
  );
};

export default Reminder;

Reminder.propTypes = {
  shortCode: string.isRequired,
  notification: object.isRequired,
  applyOptimisticUpdate: func.isRequired,
  refetch: func.isRequired,
};
